// import { axios, qs } from "axios";
import store from "../store";
import router from "../router";
import { Toast, Dialog } from "vant";
import Cookies from "js-cookie";
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_URL, // api 的 VUE_APP_URL
  timeout: 100000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
});
function startLoading() {
  // 开始加载
  // Toast.loading({
  //   message: "Loading...",
  //   forbidClick: true,
  //   duration: 0,
  // });
}
function endLoading() {
  // 结束加载
  Toast.clear();
}

// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
  (config) => {
    if (config.url == "/attachment/uploading") {
      config.headers = {
        "Content-Type":
          "multipart/form-data;boundary = " + new Date().getTime(),
      };
    }

    startLoading();
    let loginInfo = store.state.loginInfo || null;
    if (loginInfo) {
      config.headers[
        "Authorization"
      ] = `${loginInfo.token_type} ${loginInfo.access_token}`;
    }

    const language = Cookies.get("language") || "zh-CN";
    config.headers["Lang"] = language;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
  (response) => {
    endLoading();
    if (response.data.code != 200) {
      Dialog.alert({
        message: response.data.message,
      }).then(() => {});
    }
    return response.data;
  },
  (error) => {
    endLoading();
    if (error.response !== undefined) {
      const { data } = error.response;
      if (data.code == 430 || data.code == 401) {
        Dialog.alert({}).then(() => {
          store
            .dispatch("actionsMoreInfo")
            .then(() => {
              router.push({ path: "/login" });
            })
            .catch((error) => {});
        });
      } else {
        Dialog.alert({
          message: data.message,
        }).then(() => {});
      }
    }
    return Promise.reject(error);
  }
);
export default service;
